import React from "react";
import Chart from "@/components/Chart";

function makeDataEveryDay(data,days) {
  let dateMap = new Map()
  data.forEach(element => {
    dateMap[element._id] = element.total;
  });
  let result = []
  for (var i in days) {
    if (dateMap.hasOwnProperty(days[i])) {
      result.push(dateMap[days[i]])
    } else {
      result.push(0)
    }
  }
  return result
}

export default function ({ data, days }) {
  const unused = makeDataEveryDay(data.length > 0 ? data[0].value : [],days)
  const used = makeDataEveryDay(data.length > 1 ? data[1].value : [],days)
  const invalid = makeDataEveryDay(data.length > 2 ? data[2].value : [],days)
  return (
    <Chart
      option={{
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: days,
        },
        tooltip: {
          trigger: 'axis'
        },
        yAxis: {
          type: "value",
        },
        legend: {
          data: ['领取', '使用', '过期'],
        },
        series: [
          {
            name: '领取',
            data: unused,
            type: "line",
            smooth: true,
          },
          {
            name: '使用',
            data: used,
            type: "line",
            smooth: true,
          },
          {
            name: '过期',
            data: invalid,
            type: "line",
            smooth: true,
          },
        ],
      }}
    />
  );
}
